const getFetchTopCitiesRequestState = (state) => {
  return state.main.analyticsState.fetchTopCitiesRequestState
}
const getTopCities = (state) => {
  return state.main.analyticsState.topCities
}

const getFetchPeakHourRequestState = (state) => {
  return state.main.analyticsState.fetchPeakHourRequestState
}
const getPeakHour = (state) => {
  return state.main.analyticsState.peakHour
}
const getFetchAverageDurationRequestState = (state) => {
  return state.main.analyticsState.fetchAverageDurationRequestState
}
const getAverageDuration = (state) => {
  return state.main.analyticsState.averageDuration
}
const getFetchTopVouchersRequestState = (state) => {
  return state.main.analyticsState.fetchTopVouchersRequestState
}
const getTopVouchers = (state) => {
  return state.main.analyticsState.topVouchers
}
const getFetchTopSitesRequestState = (state) => {
  return state.main.analyticsState.fetchTopSitesRequestState
}
const getTopSites = (state) => {
  return state.main.analyticsState.topSites
}
const getFetchOverviewRequestState = (state) => {
  return state.main.analyticsState.fetchOverviewRequestState
}
const getOverview = (state) => {
  return state.main.analyticsState.overview
}
const getFetchTransactionsStatisticsRequestState = (state) => {
  return state.main.analyticsState.fetchTransactionsStatisticsRequestState
}
const getTransactionsStatistics = (state) => {
  return state.main.analyticsState.transactionsStatistics
}
const getFetchUserSignupRequestState = (state) => {
  return state.main.analyticsState.fetchUserSignupRequestState
}
const getUserSignup = (state) => {
  return state.main.analyticsState.userSignup
}
const getFetchTopUsersRequestState = (state) => {
  return state.main.analyticsState.fetchTopUsersRequestState
}
const getTopUsers = (state) => {
  return state.main.analyticsState.topUsers
}
const getUsersActivityRequestState = (state) => {
  return state.main.analyticsState.fetchUsersActivityRequestState
}
const getUsersActivity = (state) => {
  return state.main.analyticsState.usersActivity
}
const getUsersStatisticsRequestState = (state) => {
  return state.main.analyticsState.fetchUsersStatisticsRequestState
}
const getUsersStatistics = (state) => {
  return state.main.analyticsState.usersStatistics
}
const getEnergyChartRequestState = (state) => {
  return state.main.analyticsState.fetchEnergyChartcRequestState
}
const getEnergyChart = (state) => {
  return state.main.analyticsState.energyChart
}
const getTimeForFirstChargeRequestState = (state) => {
  return state.main.analyticsState.fetchTimeForFirstChargeRequestState
}
const getTimeForFirstCharge = (state) => {
  return state.main.analyticsState.timeForFirstCharge
}
const getTimeBetweenTransRequestState = (state) => {
  return state.main.analyticsState.fetchTimeBetweenTransRequestState
}
const getTimeBetweenTrans = (state) => {
  return state.main.analyticsState.timeBetweenTrans
}
const getPaymentBreakdownRequestState = (state) => {
  return state.main.analyticsState.fetchPaymentBreakdownRequestState
}
const getPaymentBreakdown = (state) => {
  return state.main.analyticsState.paymentBreakdown
}
const AnalyticsSelectors = {
  getFetchTopCitiesRequestState,
  getTopCities,
  getFetchPeakHourRequestState,
  getPeakHour,
  getFetchAverageDurationRequestState,
  getAverageDuration,
  getFetchTopVouchersRequestState,
  getTopVouchers,
  getFetchTopSitesRequestState,
  getTopSites,
  getFetchOverviewRequestState,
  getOverview,
  getFetchTransactionsStatisticsRequestState,
  getTransactionsStatistics,
  getFetchUserSignupRequestState,
  getUserSignup,
  getFetchTopUsersRequestState,
  getTopUsers,
  getUsersActivityRequestState,
  getUsersActivity,
  getUsersStatisticsRequestState,
  getUsersStatistics,
  getEnergyChartRequestState,
  getEnergyChart,
  getTimeForFirstChargeRequestState,
  getTimeForFirstCharge,
  getTimeBetweenTransRequestState,
  getTimeBetweenTrans,
  getPaymentBreakdownRequestState,
  getPaymentBreakdown,
}

export default AnalyticsSelectors
